import axios from "axios";
import global from "@/global"

axios.defaults.headers.post['Content-Type'] = 'application/json';
// Security: Keys are now injected by the Backend Proxy (/api-proxy)
// axios.defaults.headers.post['X-Parse-Application-Id'] = REMOVED
// axios.defaults.headers.post['X-Parse-REST-API-Key'] = REMOVED
axios.defaults.headers.post['X-Parse-Session-Token'] = ''


/* axios.interceptors.response.use(success, error) */